const API_BASE_URL = (
  process.env.REACT_APP_LEAD_GEN_API_BASE_URL ||
  'https://rscoreapi.azurewebsites.net'
).replace(/\/+$/, '')

async function request(path, { method = 'GET', body, signal } = {}) {
  let response
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method,
      headers: {
        Accept: 'application/json',
        ...(body ? { 'Content-Type': 'application/json' } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
      signal,
    })
  } catch (error) {
    if (error.name === 'AbortError') throw error
    throw new Error('Could not reach the server. Please check your connection and try again.')
  }

  const json = await response.json().catch(() => null)

  if (!response.ok || json?.success === false) {
    const error = new Error(json?.message || `Request failed with status ${response.status}`)
    error.status = response.status
    throw error
  }

  return json?.data ?? json
}

export function resolvePublicPage({ host, path }, { signal } = {}) {
  const params = new URLSearchParams({ host, path })
  return request(`/api/lead-generation/public/resolve?${params}`, { signal })
}

export function submitLead(publicKey, lead) {
  return request(`/api/lead-generation/public/${encodeURIComponent(publicKey)}/submit`, {
    method: 'POST',
    body: lead,
  })
}

const text = (value) => (typeof value === 'string' ? value.trim() : '')

function splitName(value) {
  const [first = '', ...rest] = text(value).split(/\s+/).filter(Boolean)
  return { first, last: rest.join(' ') }
}

// Templates name their fields differently, so accept the common variants.
export function toValuationPayload(values) {
  const name =
    text(values.name) || [text(values.firstName), text(values.lastName)].filter(Boolean).join(' ')

  return {
    name,
    email: text(values.email),
    phone: text(values.phone),
    propertyAddress: text(values.propertyAddress) || text(values.address),
  }
}

export function toEventPayload(values) {
  return {
    name: [text(values.firstName), text(values.lastName)].filter(Boolean).join(' '),
    email: text(values.email),
    phone: text(values.phone),
  }
}

export function toAssignmentPayload(values) {
  const person = splitName(values['d-name'] || values.name)

  return {
    firstName: text(values.firstName) || person.first,
    lastName: text(values.lastName) || person.last,
    email: text(values['d-email'] || values.email),
    phone: text(values['d-phone'] || values.phone),
  }
}

export function toReferralPayload(values, interests = []) {
  const referred = splitName(values.referralName)

  return {
    referrerName: text(values.referrerName),
    referrerPhone: text(values.referrerPhone),
    referrerEmail: text(values.referrerEmail),
    referredFirstName: referred.first,
    referredLastName: referred.last,
    referredPhone: text(values.referralPhone),
    referredEmail: text(values.referralEmail),
    relationship: text(values.relationship),
    realEstateInterest: interests.join(', '),
    timeframe: text(values.timeline).replace(/[\u2013\u2014]/g, '-'),
    notes: text(values.notes),
    consent: values.consent !== undefined,
  }
}
